import { httpClient } from "@bw/shared/api";
import type { UUID } from "@bw/shared/types";
import type {
  OrgResponse,
  PlatformOnboardingPipeline,
  Schema,
} from "@bw/shared/types/generated";

export async function listOnboardingOrgs(): Promise<PlatformOnboardingPipeline> {
  return httpClient.get<PlatformOnboardingPipeline>("/platform/onboarding");
}

export async function getOrg(orgId: UUID): Promise<OrgResponse> {
  return httpClient.get<OrgResponse>(`/platform/orgs/${orgId}`);
}

export async function approveOrg(orgId: UUID): Promise<void> {
  return httpClient.post<void>(`/platform/orgs/${orgId}/approve`);
}

export async function rejectOrg(orgId: UUID, reason: string): Promise<void> {
  const payload: Schema["OrgRejectRequest"] = { reason };
  return httpClient.post<void>(`/platform/orgs/${orgId}/reject`, payload);
}

export async function startReview(orgId: UUID): Promise<void> {
  return httpClient.post<void>(`/platform/orgs/${orgId}/start-review`);
}
